module.exports = __webpack_public_path__ + "img/28.df7d02c0.jpg";